module.exports = __webpack_public_path__ + "static/5-c3c322d90c207fab05febf36b2e44974.jpg";